import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { normalizeChannel } from 'shared/redux/helpers/normalized';
import vodAdapter from 'shared/utils/adapters/vod';

import getDefaultChannelDealInfo from 'shared/constants/channel-deal-info';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function getChannel(method, id, options) {
  return function (dispatch, getState) {
    const params = { id, options };
    dispatch(START(params));

    return vodAdapter.list[method](id, options)
      .then(
        function (response) {
          const data = response.data;
          const { vodSettings } = getState();

          if (!_.get(data, 'dealInfo.length') && vodSettings) {
            data.dealInfo = getDefaultChannelDealInfo(vodSettings.currency);
          }

          response = {
            ...response,
            data: normalizeChannel(data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.video.get' } }));
        }
      );
  };
}


export default _.partial(getChannel, 'get');

export const getPublic = _.partial(getChannel, 'getPublic');



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/get.js